export default __webpack_public_path__ + "static/media/space-landing-page.a8c8552e.png";